import gql from 'graphql-tag';
import axios from 'axios';
import graphqlClient from '../helpers/graphqlClient';
import { lockGameStages } from '@/helpers/constants';
import { profileLockFragment } from '@/helpers/graphql/fragments';

export default new (class {
	async getData(studentId, usePasscodes) {
		const filters = [];

		/*filters.push(`id=${usePasscodes}`);

		const { data } = await this.getProfileData(studentId);

		return data[0];*/

		filters.push(`id=${studentId}`);
		const { data } = await graphqlClient.query({
			query: gql`
				query profileData($where: String!) {
					students(where: $where) {
						id
						marital_Status_ID
						numberOfPets
						currentCreditScore
						studentLoanDebt
						totalStudentLoan
						minimumStudentLoanPayment
						isTransferToNextLifeStagePending
						spouseNetMonthlyIncome
						netMonthlyIncome
						currentSimulationType
						isEntryVirtualSimulationType
						mortgageLoanOutstandingAmount
						mortgageLoanInterestAmount
						autoLoanOutstandingAmount
						autoLoanInterestAmount
						isApprovedAndUsedForMortgageLoan
						isApprovedAndUsedForAutoLoan
						isApprovedAndUsedForAutoLoanDealership
						studentChildren {
							id
							ageGroup
						}
						cmsMaritalStatus {
							status
						}
						cmsCareerJobTitle {
							jobTitle
							salary
						}
						cmsEducation {
							tuition
							name
						}
						cmsLifeStage {
							name
							creditCardLimit
							timeSpanMonths
							displayOrder
						}
						studentCreditScores {
							id
							score
						}
						simulation {
							isPaused
							percentageOfNmiToSavings
							isCreditCardEnable
						}
						${usePasscodes ? '...passcodeLockStages' : ''}
					}
				}
				${usePasscodes ? profileLockFragment : ''}
			`,
			fetchPolicy: 'no-cache',
			variables: {
				where: filters.join('&&')
			}
		});
		return data.students[0];
	}

	async getProfileData(studentId) {
		return new Promise((resolve, reject) => {
			axios
				.get('/api/Account/ProfileData', {
					withCredentials: true,
					headers: {
						'Cache-Control': 'no-cache'
					},
					params: {
						studentId: studentId
					}
				})
				.then(resp => {
					resolve(resp);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	async getPauseState(studentId) {
		const { data } = await graphqlClient.query({
			query: gql`
                {
                    students(where: "id=${studentId}") {
                        id
						simulation{
							isPaused
						}
                    }
                }
                `,
			fetchPolicy: 'no-cache'
		});
		return data.students[0].simulation.isPaused;
	}

	async updatePasscodeValidation(studentId, lockStage) {
		// TODO: Update this to enable other lock stages
		const lockKeysMap = {
			[lockGameStages.BUDGETING]: 'isAfterSetBudgetUnlockedWithPasscode',
			[lockGameStages.LIFE_SCENARIO]: 'isAfterLifeScenarioUnlockedWithPasscode',
			[lockGameStages.LIFE_STAGE_SUMMARY]:
				'isAfterLifeStageSummaryUnlockedWithPasscode',
			[lockGameStages.AFTER_CALCULATE_NMI]:
				'isAfterCalculateNMIUnlockedWithPasscode',
			[lockGameStages.AFTER_LIFE_STAGE_INTRO]:
				'isAfterLifeStageIntroUnlockedWithPasscode'
		};

		const passcodeData = {
			id: studentId,
			[lockKeysMap[lockStage]]: true
		};

		const { data } = await graphqlClient.mutate({
			mutation: gql`
				mutation($update: StudentInputObjectGraphType!) {
					updateIgnoreNullValuesStudent(update: $update) {
						id
					}
				}
			`,
			variables: {
				update: passcodeData
			}
		});

		if (data) {
			return true;
		}

		return false;
	}
})();
